
import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DatePicker from 'react-datepicker';
import { Link } from 'react-router-dom';   
import 'react-datepicker/dist/react-datepicker.css';

const cardData = [
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    link: "/GalleryPage1"  ,
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  }
];
const cardData1 = [
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },

];
const cardData2 = [
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  },
  {
    imageUrl: "https://res.cloudinary.com/dzngpgki4/image/upload/v1745705697/image_55_klso3x.png",
    date: "March 03, 2025",
    title: "Market Access",
    description: "Market access is a critical element of successful farming"
  }
];

const Gallery = () => {
  const [openingDate, setOpeningDate] = useState(null);
  const [showOpening, setShowOpening] = useState(false);

  const [closingDate, setClosingDate] = useState(null);
  const [showClosing, setShowClosing] = useState(false);

  return (
    <div className='bg-white'>
      <div className='md:px-24 px-4 md:pt-6 pt-3'>
        <div>
          <div className="md:mb-6 mb-3">
            <div className="text-left">

            </div>
            <div className=" ">
              <h2 className="text-[10px] md:text-[36px] font-bold text-[#FDBD26] ">
                Gallery
              </h2>
              <h2 className="text-[8px] md:mt-4 md:text-[32px] font-normal text-black ">
                Follow the activities of Farmers Networks and read the history of Farmnet App
              </h2>

            </div>
          </div>

          <div className="w-full md:mb-4 mb-2">
            <div className="relative">
              <input
                placeholder="Search"
                type="text"
                className="w-full md:h-[61px] h-[30px] text-[#979797] text-[10px] md:text-[16px] font-semibold md:p-3 pr-10 p-1  md:px-6 px-3 border border-[#C4C4C4] md:rounded-md  rounded-full focus:outline-none focus:ring-2 focus:ring-green-600"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1744490602/Search_k7vxkr.png"
                alt="Search Icon"
                className="w-[18px] h-[15px] md:h-[24px] md:w-[24px] absolute right-5 top-1/2 transform -translate-y-1/2"
              />
            </div>
          </div>
          <div className=" md:mb-5 md:mt-5 mb-3">
            <h1 className="md:text-[16px] text-[8px] font-bold">Dates</h1>
            <div className="flex  md:flex-row md:space-x-16 space-x-4  md:space-y-0 text-[#19253C] md:mt-4 mt-2">

              {/* Opening Date */}
              <div className="flex flex-col relative">
                <div
                  onClick={() => setShowOpening(!showOpening)}
                  className="flex md:space-x-1 space-x-1 items-center cursor-pointer"
                >
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745705007/Date_range_duotone_yb2xfe.png"
                    alt="calendar"
                    className="md:w-[32px] md:h-[32px] h-[15px]"
                  />
                  <h1 className="md:text-[14px] text-[6px] font-bold">
                    From {openingDate ? openingDate.toLocaleDateString() : ''}
                  </h1>

                </div>
                {showOpening && (
                  <div className="absolute z-50 mt-2">
                    <DatePicker
                      selected={openingDate}
                      onChange={(date) => {
                        setOpeningDate(date);
                        setShowOpening(false);
                      }}
                      inline
                    />
                  </div>
                )}
              </div>

              {/* Closing Date */}
              <div className="flex flex-col relative">
                <div
                  onClick={() => setShowClosing(!showClosing)}
                  className="flex md:space-x-1 space-x-1 items-center cursor-pointer"
                >
                  <img
                    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745705007/Date_range_duotone_yb2xfe.png"
                    alt="calendar"
                    className="md:w-[32px] md:h-[32px] h-[15px]"
                  />
                  <h1 className="md:text-[14px] text-[6px] font-bold">
                    TO {closingDate ? closingDate.toLocaleDateString() : ''}
                  </h1>

                </div>
                {showClosing && (
                  <div className="absolute z-50 mt-2">
                    <DatePicker
                      selected={closingDate}
                      onChange={(date) => {
                        setClosingDate(date);
                        setShowClosing(false);
                      }}
                      inline
                    />
                  </div>
                )}
              </div>
            </div>


          </div>
        </div>
        <div>
          <div className="flex justify-between items-center md:mb-0 mb-1">
            <h2 className="text-[8px] md:text-[32px] font-bold">
              General
            </h2>
            <button className="text-[8px] md:text-[20px] flex items-center space-x-2 md:mb-0">
              <span>View more</span>
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745513012/Expand_down_8_nldzk1.png"
                alt="Expand"
                className="w-2 h-2 md:flex hidden md:w-9 md:h-8"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745511779/Expand_down_7_y6mkyp.png"
                alt="Expand"
                className="w-3 h-3 md:hidden flex md:w-6 md:h-6"
              />
            </button>
          </div>
          <div className="grid md:gap-8 gap-2 grid-cols-2">
  {cardData.map((card, index) => (
    <Link to="/GalleryPage1" key={index} className="flex flex-col items-start">
      <img
        src={card.imageUrl}
        alt={card.title}
        className="md:h-[390px] h-[100px] w-full object-cover rounded-lg"
      />
      <p className="text-black md:text-base text-[6px] font-normal mt-2 md:mt-4 text-left">{card.date}</p>
      <h2 className="md:text-[32px] text-[8px] font-bold md:mt-2 mt-0 text-left">{card.title}</h2>
      <p className="md:text-[32px] text-[8px] font-normal md:-mt-1 leading-tight text-left">{card.description}</p>
    </Link>
  ))}
</div>
        </div>


      </div>
      <div className="md:mt-10">

        <div className="bg-[#152C24] py-4">
          <div className="md:px-24 px-4">
            <div className="flex justify-between items-center md:mb-4 md:mt-8 mb-1">
              <h2 className="text-[8px] md:text-[32px] font-bold text-white">
                Event
              </h2>
              <button className="text-[8px] md:text-[20px] flex items-center space-x-2 md:mb-0">
                <span className="text-white">View more</span>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745513012/Expand_down_8_nldzk1.png"
                  alt="Expand"
                  className="w-2 h-2 md:flex hidden md:w-9 md:h-8"
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745511779/Expand_down_7_y6mkyp.png"
                  alt="Expand"
                  className="w-3 h-3 md:hidden flex md:w-6 md:h-6"
                />
              </button>
            </div>

            <div className="grid md:gap-8  gap-2 grid-cols-2">
              {cardData1.map((card, index) => (
                
                <Link to="/GalleryPage1" key={index} className="flex flex-col items-start">
                  <img
                    src={card.imageUrl}
                    alt={card.title}
                    className="md:h-[390px] h-[100px] w-full object-cover rounded-lg"
                  />
                  <p className="text-white md:text-base   text-[6px] font-normal mt-2  md:mt-4 text-left">{card.date}</p>
                  <h2 className="md:text-[32px]  text-[8px]  text-white  font-bold md:mt-2 mt-0 text-left">{card.title}</h2>
                  <p className="md:text-[32px]  text-[8px]   text-white  font-normal md:-mt-1 leading-tight text-left">{card.description}</p>
     </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className='md:px-24 px-4 md:pt-4 pt-3'>

        <div>
          <div className="flex justify-between items-center md:mb-4 mb-1">
            <h2 className="text-[8px] md:text-[32px] font-bold">
              History
            </h2>
            <button className="text-[8px] md:text-[20px] flex items-center space-x-2 md:mb-0">
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745513012/Expand_down_8_nldzk1.png"
                alt="Expand"
                className="w-2 h-2 md:flex hidden md:w-9 md:h-8"
              />
              <img
                src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745511779/Expand_down_7_y6mkyp.png"
                alt="Expand"
                className="w-3 h-3 md:hidden flex md:w-6 md:h-6"
              />
            </button>
          </div>
          <div className="grid md:gap-8  gap-2 grid-cols-2">
            {cardData2.map((card, index) => (
              <Link to="/GalleryPage1" key={index} className="flex flex-col items-start">
                <img
                  src={card.imageUrl}
                  alt={card.title}
                  className="md:h-[390px] h-[100px] w-full object-cover rounded-lg"
                />
                <p className="text-black md:text-base  text-[6px] font-normal mt-2  md:mt-4 text-left">{card.date}</p>
                <h2 className="md:text-[32px]  text-[8px] font-bold md:mt-2 mt-0 text-left">{card.title}</h2>
                <p className="md:text-[32px]  text-[8px]  font-normal md:-mt-1 leading-tight text-left">{card.description}</p>
</Link>
            ))}
          </div>
        </div>


      </div>
    </div>
  )
}

export default Gallery